import React, { type FC, memo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { FormattedMessage } from "react-intl";

import { markdownComponents } from "@app/pages/static/LegalDocumentView";
import { Lang } from "@domain/intl";
import { useTranslation } from "@domain/intl/useTranslation";
import { formatReleaseNoteDate, type ReleaseNote } from "@domain/models/ReleaseNotes";

const remarkPlugins = [remarkGfm];

export const ReleaseNoteMeta: FC<{ note: ReleaseNote }> = ({ note }) => {
    const { t } = useTranslation();
    return (
        <span className="text-xs text-muted">
            {t("app.releaseNotes.version", { version: note.version })}
            {" · "}
            {formatReleaseNoteDate(note.date)}
        </span>
    );
};

const ReleaseNoteBodyImpl: FC<{ note: ReleaseNote }> = ({ note }) => {
    const { locale } = useTranslation();
    return (
        <div>
            {locale !== Lang.De && (
                <p className="mb-3 text-sm text-muted">
                    <FormattedMessage id="app.releaseNotes.germanOnly" />
                </p>
            )}
            <ReactMarkdown remarkPlugins={remarkPlugins} components={markdownComponents}>
                {note.bodyMd}
            </ReactMarkdown>
        </div>
    );
};

export const ReleaseNoteBody = memo(ReleaseNoteBodyImpl);
